import { errnoDataMiddleware } from './middlewares';

export function applyPromiseMiddleware(middlewares = []) {
  return (method, ...params) => {
    return middlewares.reduce((response, middleware) => {
      return middleware(
        {
          method,
          params,
        },
        response
      );
    }, method.apply(null, params));
  };
}

export const requestDataHelper = applyPromiseMiddleware([errnoDataMiddleware]);
